/**
 * WorkgateDialog の入出力ヘルパー。
 *
 * localStorage の読み出しと displayDialog ログ送信を SFC から切り出したもの。
 * 送信先 URL とトランスポート（FormData）は呼び出し側から渡し、
 * 従来と1バイトも変えない（エンドポイントは $varuna.endPoints 由来）。
 */

/** バックアップ対象のストレージキー。ここに無いキーは読まない */
const BACKUP_KEYS_LIST = [
  'format_rirekisho',
  'format_shokumukeirekisho',
  'basicData',
  'recentEdit'
]

type IterateStorage = (
  onEach: (value: unknown, key: string, index: number) => void,
  onError: (err: unknown) => void
) => Promise<unknown>

export interface StoredResumeData {
  storageData: Record<string, any>
  basic: Record<string, any> | null
  formatData: Record<string, any> | null
  resume: Record<string, any> | null
}

/** localStorage から履歴書・職務経歴書・基本情報を読む */
export async function loadStoredResumeData(
  iterateStorage: IterateStorage,
  basicDataFromCaller?: Record<string, any> | null
): Promise<StoredResumeData> {
  const storageData: Record<string, any> = {}
  await iterateStorage(
    function (value, key) {
      if (BACKUP_KEYS_LIST.indexOf(key) !== -1) {
        storageData[key] = value
      }
    },
    function (err) {
      if (err) {
        console.error(err)
      }
    }
  )
  return {
    storageData,
    basic: basicDataFromCaller || storageData.basicData || null,
    formatData: storageData.format_rirekisho || null,
    resume: storageData.format_shokumukeirekisho || null
  }
}

interface HttpPost {
  post: (url: string, body: unknown, config: unknown) => unknown
}

/** displayDialog へ表示ログを送る。失敗は待たない（表示を止めない） */
export function postDisplayDialogLog(
  http: HttpPost,
  url: string,
  fields: Record<string, string | number>
): void {
  const form = new FormData()
  Object.keys(fields).forEach((k) => form.append(k, String(fields[k])))
  http.post(url, form, { timeout: 60000 })
}
